import {requestCreate, requestDelete, requestUpdate} from "../api"
import {
    RESET_FORM,
    RESET_STATE,
    SET_FORM
} from "../constant-types"
import { defaultAddToOptionMutation, defaultLoadOptionAction, defaultRemoveFromOptionMutation, defaultSetOptionMutation, defaultUpdateInOptionMutation } from "../default-method"
import {
    updateField,
    getField
} from "vuex-map-fields";

const getDefaultState = () => {
    return {
        options: [],
        option_url: 'category-class/option',
        form : getDefaultFormState()
    }
}

const getDefaultFormState = () => {
    return {
        id : '',
        related_table : '',
        name : '',
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetOptionMutation,
        ...defaultUpdateInOptionMutation,
        ...defaultAddToOptionMutation,
        ...defaultRemoveFromOptionMutation,
        [RESET_FORM](state, relatedTable) {
            state.form = getDefaultFormState()
            state.form.related_table = relatedTable
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, {
                id : payload.id,
                related_table: payload.related_table,
                name: payload.name,
            })
        },
        updateField
    },
    // can async
    actions: {
        ...defaultLoadOptionAction,
        requestCreateCategoryClass({commit, state}) {
            requestCreate('category-class', state.form, commit, 'ADD_TO_OPTION')
        },
        requestUpdateCategoryClass({commit, state}) {
            requestUpdate(`category-class/${state.form.id}`, state.form, commit, 'UPDATE_IN_OPTION')
        },
        requestDeleteCategoryClass({commit, state}, categoryClass) {
            requestDelete(`category-class/${categoryClass.id}`, {}, commit, categoryClass.name, 'REMOVE_FROM_OPTION')
        }
    },
    // call variable with custom display
    getters: {
        optionByRelatedTable: (state) => relatedTable => state.options.filter(o => o.related_table === relatedTable),
        categoryClassNameById: state => categoryClassId => 
            state.options.length > 0 ? state.options.find(o => o.id === +categoryClassId ).name
            : '---',
        getField
    }
})
